var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chooser-component"},[_c('ul',{staticClass:"chooser-list"},_vm._l((_vm.banks),function(item,index){return _c('li',{class:[item.name, {active: index === _vm.nowIndex}],attrs:{"title":item.label},on:{"click":function($event){return _vm.chooseSelection(index)}}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7e45460","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bankChooser.vue
// module id = null
// module chunks = 